
import { useMutation } from 'react-query';
import useApi from './useApiRequest';


export const useDownloadBackup = () => {
  const api = useApi();

  const mutate = async () => {
    const response = await api.get('/backup/download', {
      responseType: 'blob',
    });

    const disposition = response.headers?.['content-disposition'] ?? '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const fileName = match?.[1] ?? 'backup.sql';

    const blob = response.data instanceof Blob
      ? response.data
      : new Blob([response.data]);

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const mutation = useMutation(mutate);

  return {
    downloadBackup: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};